<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #dfe8f4 !important; height: 30em !important;">
                <img src="/static/images/ducks.svg" style="height: 10rem !important" />
                <span class="mt-5">
                    Are you sure you want to <span style="color: #e82828">Terminate</span> <br/> {{ employee_name }} from the employees?
                </span>
                <div class="d-flex aligin-items-center justify-content-center mt-5">     
                    <button
                        class="btn btn-new-danger btn-smm"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="hideSelf"
                    >CANCEL</button>   
                    <button
                        type="button"
                        class="btn btn-new-green btn-smm ml-3"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="terminateEmployee"
                    >TERMINATE</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","employee_name"],
    methods: {
        terminateEmployee() {
            this.$emit("terminateEmployee");
        },
        hideSelf() {
            this.$modal.hide(this.modal_name);
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/TerminateEmployee.vue